
import { Theme } from '@mui/material/styles';

export const getPageStyles = (theme: Theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        '& > *': {
            margin: theme.spacing(2)
        },
    },
    toggleBtn: {
        width: '13rem',
        paddingLeft: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    maxHeight: {
        overflowY: 'scroll',
        maxHeight: '30rem'

    },
    pageControls: {
        width: "100%",
        alignContent: "right"
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        width: '100vw',
        overflow: 'auto',
    },
    dfb: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    dfe: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 0
    },
    errMsg: {
        width: '15rem',
        color: 'red'
    },
    successMsg: {
        width: '15rem',
        color: 'green'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '75%'
    },
    ml2: {
        marginLeft: theme.spacing(2),
    },
    mt2: {
        marginTop: theme.spacing(2),
    },
    mb2: {
        marginBottom: theme.spacing(2),
    },
    fileUpload: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#e3e8ea',
        height: '30vh',
        border: '2px dashed gray',
        cursor: 'pointer'
    },
    lt: {
        fontSize: '2rem'
    },
    verticalBtn: {
        margin: 'auto',
        width: '12rem',
        marginTop: theme.spacing(1),
    },
    plainBtn: {
        backgroundColor: '#E0E0E0',
        color: '#000000',
        '&:hover': { backgroundColor: '#D5D5D5' }
    },
    table: {
        minWidth: 650,
        cursor: 'pointer'
    },
    highlight: {
        backgroundColor: '#3B4B95',
        '& > *': { color: 'white' }
    },
    warningTooltip: {
        color: theme.palette.warning.light
    }
});

export const getAddModalStyles = (theme: Theme) => ({
    paper: {
        position: 'absolute',
        width: '28vw',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3),
    },
    mt2: {
        marginTop: theme.spacing(2)
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    dfr: {
        flexDirection: 'row'
    },
    redTxt: {
        color: 'red'
    },
    greenTxt: {
        color: 'green'
    },
    dflex: {
        display: 'flex'
    },
    dnone: {
        display: 'none'
    },
    stickToBottom: {
        bottom: theme.spacing(2),
        position: 'absolute'
    },
    addModal: {
        top: `5%`,
        left: `36vw`,
    },
    cbs: {
        color: '#556cd6',
        '&.Mui-checked': {
            color: 'green',
        }
    },
    checked: {},
});

export const getEditModalStyles = (theme: Theme) => ({
    paper: {
        position: 'absolute',
        width: '25vw',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3),
    },
    mt2: {
        marginTop: theme.spacing(2)
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    dfr: {
        flexDirection: 'row'
    },
    redTxt: {
        color: 'red'
    },
    greenTxt: {
        color: 'green'
    },
    editModal: {
        top: `5%`,
        left: `37.5vw`,
    },
    cbs: {
        color: '#556cd6',
        '&.Mui-checked': {
            color: 'green',
        }
    },
    checked: {},
    dflex: {
        display: 'flex'
    },
    dnone: {
        display: 'none'
    },

});

export const getDeleteModalStyles = (theme: Theme) => ({
    paper: {
        position: 'absolute' as const,
        width: '25vw',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3),
    },
    mt2: {
        marginTop: theme.spacing(2)
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    dfr: {
        flexDirection: 'row'
    },
    redTxt: {
        color: 'red'
    },
    greenTxt: {
        color: 'green'
    },
    btnDanger: {
        backgroundColor: 'red',
        color: 'white'
    },
    btnGreen: {
        backgroundColor: 'green',
        color: 'white'
    },
    deleteModal: {
        top: `5%`,
        left: `37.5vw`,
    },
    closeBtn: {
        marginLeft: theme.spacing(2),
        backgroundColor: '#E0E0E0',
        color: '#000000',
        '&:hover': { backgroundColor: '#D5D5D5' }
    },
    dflex: {
      display: 'flex'
    },
    code: {
      overflow: 'scroll',
      backgroundColor: '#f1f1f1',
      padding: '2px',
      height: '15vw'
    }
});

export default {
    pageStyles: getPageStyles,
    addModalStyles: getAddModalStyles,
    editModalStyles: getEditModalStyles,
    deleteModalStyles: getDeleteModalStyles,
};
